import { IRepository } from "@karma-games/angular-devkit/src/lib/interfaces";
import { InjectionToken } from "@angular/core";
import { IStepperConfig } from "@karma-games/angular-devkit/modules/controls-components/stepper-control/interfaces";
export const LOBBY_CONFIG_REPOSITORY_TOKEN = new InjectionToken<IRepository<ILobbyConfig>>("LobbyConfigRepository");

export interface ILobbyConfig {
    avatars: string[];
    languages: string[];
    currencyRelativeValues: IRelativeCurrencyValues[],
    autoplay: IAutoplayOptionsConfig;
    bet: IBetOptionsConfig;
    autoCashOutMultiplier: IMultiplierOptionsConfig;
    idleDuration: number;
    maxWinAmount: number;
    balanceAvailable: boolean;
    minBet: number;
    maxBet: number;
    maxMultiplier: number;
}

export interface IBetOptionsConfig {
    predefinedAmounts: number[];
    stepper: IStepperConfig;
}

export interface IMultiplierOptionsConfig {
    stepper: IStepperConfig;
}

export interface IAutoplayOptionsConfig {
    rounds: number[];
    cashIncreaseStopStepper: IStepperConfig;
    cashDecreaseStopStepper: IStepperConfig;
    singleWinStopStepper: IStepperConfig;
}

export interface IRelativeCurrencyValues {
    currency: string;
    value: number;
}
